import { gql, useLazyQuery } from '@apollo/client';
import { UserAuthContext } from 'contexts/UserAuthContext';
import { ERROR_TYPE, TTError, handleException } from 'models/ErrorHandling';
import { useContext } from 'react';
import { enqueueSnackbar } from 'notistack';

export const GET_RESULT_TYPE_COUNT = gql`
    query ResultTime($where: ResultWhereInput!) {
        results(where: $where) {
            startTime
            endTime
        }
    }
`;

export type ModelQueryType = {
    results?: ResultTime[];
};
export type ResultTime = {
    startTime: string;
    endTime: string;
};

type QueryVariableType = {
    studentId: string;
};

export const useGetStudentPlayingTime = () => {
    const auth = useContext(UserAuthContext);
    const [getGetStudentTime, { data: testRoomIdsData, loading: resultsLoading }] = useLazyQuery(GET_RESULT_TYPE_COUNT);
    const getResultTime = async (_variable: QueryVariableType): Promise<ModelQueryType | null> => {
        try {
            const result = await getGetStudentTime({
                variables: {
                    where: {
                        student: {
                            id: {
                                equals: _variable.studentId,
                            },
                        },
                    },
                },
                fetchPolicy: 'no-cache',
                notifyOnNetworkStatusChange: true,
            });
            if (!result?.data) {
                throw new TTError(ERROR_TYPE.NO_DATA);
            }
            return result?.data;
        } catch (err) {
            console.log(err);
            const errorMsg = handleException(err);
            if (errorMsg === ERROR_TYPE.KS_ACCESS_DENIED) {
                auth.accessDenied(errorMsg);
            } else {
                enqueueSnackbar(errorMsg, {
                    variant: 'error',
                    anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                });
            }
            throw new TTError();
        }
        return null;
    };
    return { getResultTime };
};
